import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_account",
  "use": "svg_account-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg_account\"><circle cx=\"12\" cy=\"12\" r=\"10.5\" stroke=\"currentColor\" stroke-width=\"1.6\" /><circle cx=\"12\" cy=\"9.5\" r=\"3.4\" stroke=\"currentColor\" stroke-width=\"1.6\" /><path d=\"M5.4 19.2C6.7 16.5 9.1 15 12 15s5.3 1.5 6.6 4.2\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol